import {DeliverableClassification} from './del-classifcation';

export enum DeliverableStatus {
    active= 'active'
}

export interface Deliverable {
    classCode: string; // "0000000"
    classification: DeliverableClassification;
    decimalPlaces: number;
    deliverableId: number;
    identifier: string; // "0x0000000000000000000000000000000000000000"
    status: DeliverableStatus;
    symbol: string;
    timestamp: string | null;
}

export type DeliverableId = Deliverable['deliverableId'];

export const isDeliverablesEqual = (d1?: Deliverable, d2?: Deliverable): boolean =>
    !d1 === !d2
    && (
        !d1 || (
            d1.deliverableId === d2.deliverableId
        )
    );
